import { compact } from 'fp-ts/lib/Array';
import { Filter } from './Filter';
import { GeneralFilter } from './GeneralFilter';
import { Filters_ControlsState, Filters_Snapshot } from './types/filters.type';

/**
 * Handles creating a snapshot of the filters state
 */
export class FilterSnapshot {
    private filter: Filter;

    constructor() {
        this.filter = new GeneralFilter();
    }

    /**
     * Check if a set should be included in the snapshot based on the applied filters
     */
    public includeSetInSnapshot(filtersControls: Filters_ControlsState): boolean {
        return (
            filtersControls.filter((filter) => {
                return filter.applyFilter;
            }).length > 0
        );
    }

    public createSnapshotFromState(filtersControls: Filters_ControlsState): Filters_Snapshot {
        return compact(filtersControls.map(this.filter.createSnapshotFromState));
    }

    public createStateFromSnapshot(
        snapshotFilters: Filters_Snapshot,
        filtersControls: Filters_ControlsState
    ): Filters_ControlsState {
        return filtersControls.map((filterControls) => {
            const snapshotFilter = snapshotFilters.find((snapshotFilter) => {
                if (typeof snapshotFilter === 'string') {
                    return snapshotFilter === filterControls.identifier;
                } else {
                    return snapshotFilter.identifier === filterControls.identifier;
                }
            });

            if (snapshotFilter) {
                return this.filter.applySnapshotToControlsState(filterControls, snapshotFilter);
            }

            return filterControls;
        });
    }
    /* 
    private createBooleanFilterState(filter: BooleanFilterState): BooleanFilterState {
        return {
            ...filter,
            applyFilter: true,
            values: {
                isChecked: true,
            },
        };
    }

    private createNumberFilterState(
        snapshot: NumberRangeFilterSnapshot,
        filter: NumberRangeFilterState
    ): NumberRangeFilterState {
        return {
            ...filter,
            applyFilter: true,
            values: {
                max: {
                    ...filter.values.max,
                    currentValue: snapshot.max,
                    currentValueAsString: snapshot.max.toString(),
                },
                min: {
                    ...filter.values.min,
                    currentValue: snapshot.min,
                    currentValueAsString: snapshot.min.toString(),
                },
            },
        };
    }

    private createKeywordFilterState(snapshot: KeywordFilterSnapshot, filter: KeywordFilterState): KeywordFilterState {
        return {
            ...filter,
            applyFilter: true,
            values: {
                ...filter.values,
                keywords: filter.values.keywords.map((keyword) => {
                    if (snapshot.values.includes(keyword.key)) {
                        return { ...keyword, isChecked: true };
                    }
                    return keyword;
                }),
            },
        };
    } */
}
